import type {ContentPart} from '../store';
import type {ComposerFile} from './file';
import type {SelectedRun} from './run';

export interface AssemblePromptPartsInput {
  // Attached run chips (ambient context), prepended before the message body.
  runs: SelectedRun[];
  // The typed message; starts with a text part (empty when it leads with a mention).
  body: ContentPart[];
  // File attachments (images today), appended after the body.
  files: ComposerFile[];
}

/**
 * assemblePromptParts orders a user prompt from a draft's pieces. Run chips
 * lead as ambient context, then the message body, then files after a text
 * anchor so they survive the `getVisiblePromptParts` slice (everything before
 * the first text part is treated as ambient and dropped from display).
 */
export function assemblePromptParts({
  runs,
  body,
  files,
}: AssemblePromptPartsInput): ContentPart[] {
  const runParts: ContentPart[] = runs.map(run => ({
    type: 'wandb-run',
    entityName: run.entityName,
    projectName: run.projectName,
    runName: run.name,
    runDisplayName: run.displayName,
    runDisplayNameStatus: 'resolved',
  }));

  const parts: ContentPart[] = [...runParts, ...body];
  if (files.length > 0) {
    if (!parts.some(part => part.type === 'text')) {
      parts.push({type: 'text', text: '', status: 'complete'});
    }

    // Drop the composer-only `id`, leaving the store/wire `ImagePart`.
    for (const {id: _id, ...imagePart} of files) {
      parts.push(imagePart);
    }
  }

  return parts;
}
